import * as React from "react";

import { Header, Navigation, Footer } from "../../shared";
import { AdministrationMenu } from "../shared/menu/AdministrationMenu";
import { DataLoadBookstore } from './DataLoadBookstore';
import "./DataLoad.scss";

import {
    Grid,
    Paper,
    Snackbar,
    SnackbarContent,
    Card,
    CardContent,
    ExpansionPanel,
    ExpansionPanelSummary,
    Typography,
    ExpansionPanelDetails,
    LinearProgress,
    Dialog,
    DialogActions,
    DialogTitle,
    DialogContent,
    DialogContentText,
    Button
} from '@material-ui/core';

import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Rest from "src/services/Rest";

const styles = {
    textField: {
      marginLeft: 5,
      marginRight: 5,
    },
};


// tslint:disable-next-line:no-empty-interface
export interface IDataLoadProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IDataLoadState {
    alertMessage: string,
    alertOpened: boolean,
    alertType: string,
    bookstoreDetailToView: any,
    grpList: any[],
    loading: boolean,
    loadingDetailDays: boolean,
    openDialogDetailDays: boolean;
}

export class DataLoad extends React.Component<IDataLoadProps, IDataLoadState> {

    constructor(props: IDataLoadProps) {
        super(props);

        this.state = {
            alertMessage: '',
            alertOpened: false,
            alertType: 'success',
            bookstoreDetailToView: {},
            grpList: [],
            loading: false,
            loadingDetailDays: false,
            openDialogDetailDays: false
        }
        this.errorMessage = this.errorMessage.bind(this);
        this.openAlert = this.openAlert.bind(this);
        this.sendRequestGrpList = this.sendRequestGrpList.bind(this);
    }

    public componentDidMount () {
        this.sendRequestGrpList();
    }

    public shouldComponentUpdate(nextProps:any, nextState:any) {
        return (this.state.loading === false && nextState.loading === true) || this.state.grpList !== nextState.grpList
            || (this.state.loadingDetailDays !== nextState.loadingDetailDays) 
            || (this.state.bookstoreDetailToView !== nextState.bookstoreDetailToView);
    }

    public getSnapshotBeforeUpdate(prevProps:any, prevState:any) {
        return ( prevState.loading === true  && this.state.loading === false ) 
            || prevState.loading === this.state.loading ? null : 1;
    }

    public componentDidUpdate (prevProps:any, prevState:any, snapshot:any) {
        if(snapshot != null && !this.state.loading) {
            this.sendRequestGrpList();
        }
    }
    
    public render() {

        return (
        <div className="dataLoad-page">
            <Header title={"Cargas de Dados"} name={"Administrativo"} link={"/dashboard"} />

            <Navigation name={"Cargas de Dados"}
                linkDefault={"/administration/dataLoad"}
                link={"/dashboard"}
                linkTitle={"Produtos"}
                painel={3}
                icon={<ChevronRightIcon />}
            />

            <div className="dataLoad-body">
                <AdministrationMenu paramIcon={null} />
                <div className="wrapper">
                    <Grid
                        container={true}
                        className="dataLoad-panel dataLoad-grid"
                        spacing={16}
                    >
                        <Grid item={true} xs={12} >
                            <div>
                                <Dialog
                                    open={this.state.openDialogDetailDays}
                                    onClose={this.handleCloseDialogDetailDays}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                    <DialogTitle id="alert-dialog-title">
                                        Últimos 90 dias de carga
                                    </DialogTitle>
                                    <DialogContent>
                                        {
                                            this.state.loadingDetailDays ? 
                                                <LinearProgress /> : 
                                                <DialogContentText id="alert-dialog-description">
                                                    <Grid container={true} spacing={16}>
                                                        <Grid item={true} xs={12}>
                                                            <Typography className="bookstoreName" variant="title" align="center">
                                                                {this.state.bookstoreDetailToView.cnpj} - {this.state.bookstoreDetailToView.bs_name}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item={true} xs={10}>
                                                            <Typography variant="body1">Dia</Typography>
                                                        </Grid>
                                                        <Grid item={true} xs={2}>
                                                            <Typography variant="body1">Cupons</Typography>
                                                        </Grid>
                                                    </Grid>
                                                    {
                                                        this.state.bookstoreDetailToView.days && this.state.bookstoreDetailToView.days.map((day:any, dayKey: number) => {
                                                            return (
                                                                <Grid container={true} spacing={16} key={dayKey}>
                                                                    <Grid item={true} xs={10}>
                                                                        <Typography variant="body1">{day.dt}</Typography>
                                                                    </Grid>
                                                                    <Grid item={true} xs={2}>
                                                                        <Typography variant="body1">{day.qtd}</Typography>
                                                                    </Grid>
                                                                </Grid>
                                                            )
                                                        })
                                                    }
                                                </DialogContentText>
                                        }
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={this.handleCloseDialogDetailDays} color="primary">
                                            Fechar
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                                <Paper className='dataLoadContent'>
                                    <Grid container={true} direction="column" spacing={16}>
                                        <Grid item={true}>
                                            <Snackbar
                                                anchorOrigin={{
                                                    horizontal: 'center',
                                                    vertical: 'center',
                                                }}
                                                open={this.state.alertOpened}
                                                autoHideDuration={4000}
                                                onClose={this.closeAlert}
                                            >
                                                <SnackbarContent message={this.state.alertMessage} style={this.alertStyle()}/>
                                            </Snackbar>
                                            <Card>
                                                <CardContent>
                                                    { this.state.loading ? <LinearProgress /> :  <Grid container={true} direction="row" spacing={16}>
                                                        <Grid item={true} xs={12}>
                                                            <ExpansionPanel  expanded={false}>
                                                                <ExpansionPanelSummary
                                                                    aria-controls="panel2a-content"
                                                                    id="panel2a-header"
                                                                >
                                                                    <Grid container={true} direction="row" spacing={16}>
                                                                        <Grid item={true} xs={1}>
                                                                            <Typography>Grupo</Typography>
                                                                        </Grid>
                                                                        <Grid item={true} xs={5}>
                                                                            <Typography>Loja</Typography>
                                                                        </Grid>
                                                                        <Grid item={true} xs={2}>
                                                                            <Typography>Primeira Carga</Typography>
                                                                        </Grid>
                                                                        <Grid item={true} xs={2}>
                                                                            <Typography>Última Carga</Typography>
                                                                        </Grid>
                                                                        <Grid item={true} xs={2} />
                                                                    </Grid>
                                                                </ExpansionPanelSummary>
                                                            </ExpansionPanel>
                                                        </Grid>
                                                        <Grid item={true} xs={12}>
                                                            {
                                                                this.state.grpList.map((row: any, key: number) => {
                                                                    return (
                                                                        <ExpansionPanel key={key} onChange={this.handleExpandPanel.bind(this, row)}>
                                                                            <ExpansionPanelSummary
                                                                                expandIcon={<ExpandMoreIcon />}
                                                                                aria-controls="panel2a-content"
                                                                                id="panel2a-header"
                                                                            >
                                                                                <Grid container={true} direction="row" spacing={16} className='groupInfo'>
                                                                                    <Grid item={true} xs={6}>
                                                                                        <Typography>{row.grp_name}</Typography>
                                                                                    </Grid>
                                                                                    <Grid item={true} xs={2}>
                                                                                        <Typography>{row.min_day}</Typography>
                                                                                    </Grid>
                                                                                    <Grid item={true} xs={2}>
                                                                                        <Typography>{row.max_day}</Typography>
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </ExpansionPanelSummary>
                                                                            <ExpansionPanelDetails>
                                                                                { row.expanded ?
                                                                                <DataLoadBookstore 
                                                                                    group={row}
                                                                                    handleOpenDialogDetailDays={this.handleOpenDialogDetailDays}
                                                                                /> : 
                                                                                <></>}
                                                                            </ExpansionPanelDetails>
                                                                        </ExpansionPanel>
                                                                    )
                                                                })
                                                            }
                                                        </Grid>
                                                    </Grid>}
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </div>
            <div className="analytical-footer">
                <Footer />
            </div>
        </div>
        );
    }

    private handleExpandPanel(row: any, _: any, expanded: boolean) {
        const newGrpList = this.state.grpList.map((obj :any) => {
            if (obj.grp_id === row.grp_id){
                return {
                    expanded: true,
                    grp_id: obj.grp_id,
                    grp_name: obj.grp_name,
                    max_day: obj.max_day,
                    min_day: obj.min_day
                }
            } else {
                return obj;
            }
        })
        this.setState({ grpList: newGrpList });
    }

    /**
     * Métodos mensagem de alert
     */
    private alertStyle = () => {
        return styles[this.state.alertType];
    }

    private errorMessage(msg: string) {
        this.openAlert(true, 'error', msg || 'Falha ao salvar registro.');
    }

    private openAlert(alertOpened: boolean, alertType: string, alertMessage: string) {
        this.setState({ alertType, alertMessage, alertOpened });
    }

    private closeAlert = (event: object, reason: string) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ alertOpened: false });
    }
    
    private sendRequestGrpList () {
        if(!this.state.loading) {
            this.setState({ loading: true });
            Rest.GET('dataLoad', null)
                .then(response => response.json())
                .then((result:any) => {
                if(result != null && result !== undefined && result.length > 0) {
                    const expandedResult = result.map((obj: any) => { 
                        return {
                            expanded: false,
                            grp_id: obj.grp_id,
                            grp_name: obj.grp_name,
                            max_day: obj.max_day,
                            min_day: obj.min_day
                        }}
                    )
                    this.setState({ grpList: expandedResult, loading: false });
                }
            });
        }
    }

    /**
     * Dialog detail days
     */
    private handleOpenDialogDetailDays = (bs : any) => {
        if(!this.state.loadingDetailDays) {
            this.setState({ loadingDetailDays: true, openDialogDetailDays: true });
            Rest.GET(`dataLoad/detailDays?id=${bs.bs_id}&maxDate=${bs.dt_max}`, null)
                .then(response => response.json())
                .then((result:any) => {
                if(result != null && result !== undefined && result.length > 0) {
                    bs.days = result;
                    this.setState({ bookstoreDetailToView: bs, loadingDetailDays: false });
                } else {
                    this.setState({ bookstoreDetailToView: {}, openDialogDetailDays: false });
                    this.errorMessage('Falha ao buscar carga dos últimos 90 dias.');
                }
            });
        }
        
    };

    private handleCloseDialogDetailDays = () => {
        this.setState({ bookstoreDetailToView: {}, openDialogDetailDays: false });
    };
}



// WEBPACK FOOTER //
// ./src/component/administration/data-load/DataLoad.tsx